import deMessage from "./de/index.js";
import enMessage from "./en/index.js";
import esMessage from "./es/index.js";
import frMessage from "./fr/index.js";
import itMessage from "./it/index.js";
import ptMessage from "./pt/index.js";

export const messages = {
  en: enMessage,
  de: deMessage,
  es: esMessage,
  fr: frMessage,
  it: itMessage,
  pt: ptMessage,
};
